import {
    Box,
    Center,
    Stack,
    Text,
    Link,
    Flex,
} from "@chakra-ui/layout";

import {
    Switch,
    Tooltip,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalHeader,
    ModalBody,
    ModalContent,
    FormControl,
    Input,
    ModalCloseButton,
    FormLabel,
    ModalFooter,
    Img,
    Button,
    ButtonGroup,
    useColorModeValue,
} from "@chakra-ui/react";
import theme from "@chakra-ui/theme";
import SearchBar from "components/search-bar";
import Tweets from "components/tweets";
import { CustomHead } from "components/custom-head";
import React, { useEffect, memo } from "react";

import { useSession } from "next-auth/client";

import ProtectedRoute from "components/protected-route";
import SubscribePopup from "components/subscribe-popup";
import { Navbar } from "components/navbar";

import { getList } from "../controllers/bookmark";
import { grow, search, getKeywords, warm } from "../controllers/search";
import { useRouter } from "next/dist/client/router";
import * as analytics from "../utils/analytics";
import { firebaseClient } from "../firebaseClient";
import PuffLoader from "react-spinners/PuffLoader";
import { InfoOutlineIcon } from '@chakra-ui/icons'
import { Page } from "components/page";
import { getAccount } from "../utils/sessionHelper";
import { useFirebaseUser } from "../utils/useFirebaseUser";
import { EditKeywords } from "../components/popups/editKeywords";
import { useOnboardingSteps } from "components/onboard-panel/useOnboardingSteps";
import { useStats } from "hooks/useStats";
import { ClientPanel } from "components/queue-panels";
import { GhostwriterPanel } from "components/ghostwriter/ghostwriterPanel";
import { setInLocalStorage } from "utils/helpers";
import { variant } from "theme/names";

let tabs = [
    "client",
    "ghostwriter",
];

export const Collaboration = ({query}) => {

    const [session, loading] = useSession();
    const router = useRouter();
    const [refresh, refresher] = React.useState({});
    const [hasFetched, setHasFetched] = React.useState(false);
    const [mode, setModeInternal] = React.useState("client");
    const isAuthenticated = useFirebaseUser();

    const changeTabFromQuery = (query) => {
        if (tabs.includes(query.tab)) {
            setModeInternal(query.tab);
        }
    }

    useEffect(() => {
        changeTabFromQuery(query);
    }, [query.tab]);

    useEffect(() => {
        if (isAuthenticated && !hasFetched) {

        }
    }, [session, isAuthenticated]);

    const setMode = (newMode) => {
        router.push({
            pathname: '/collaboration',
            query: { tab: newMode }
        }, undefined, { shallow: false });
        setModeInternal(newMode);
        setInLocalStorage("collaboration_last_mode", newMode);
    };

    if (!loading && !session) {
        return <ProtectedRoute />;
    }

    const bgColor = useColorModeValue("border.lightMode.light", "border.darkMode.light");
    const bgColorHover = useColorModeValue("gray.100", "gray.700");

    return (
        <Page
            title="Collaboration"
            description="Check, review and validate content that your collaborators have written for you."
            // infoTooltipText="These tweets were selected for you by our AI engine, based on your Twitter bio and what you usually talk about."
            // contentBesidesTitle={
            //     <Button {...{ variant: "filter", ml: 4, h: 8 }}>Beta</Button>
            // }
            contentOnRightOfTitle={
                <Flex ml={2}>
                    <ButtonGroup isAttached variant="light">
                        <Button
                            // variant={"secondary"}
                            variant={mode !== "client" ? variant.Button.lightSelected : variant.Button.light}
                            // bg={mode == "ghostwriter" ? bgColor : "none"} _focus={{ boxShadow: "none" }}
                            // cursor={mode == "ghostwriter" ? "default" : "pointer"}
                            // _hover={{bg: mode == "ghostwriter" ? bgColor : bgColorHover}}
                            // size="sm"
                            // fontSize="12px"
                            mr='-px'
                            onClick={() => {
                                setMode("ghostwriter");
                            }}
                        >
                            Writer mode
                        </Button>
                        <Button
                            variant={mode === "client" ? variant.Button.lightSelected : variant.Button.light}
                            // bg={mode == "client" ? bgColor : "none"} _focus={{ boxShadow: "none" }}
                            // cursor={mode == "client" ? "default" : "pointer"}
                            // _hover={{bg: mode == "client" ? bgColor : bgColorHover}}
                            // size="sm"
                            // fontSize="12px"
                            onClick={() => {
                                setMode("client");
                            }}
                        >
                            Client mode
                        </Button>
                    </ButtonGroup>

                </Flex>
            }
        >
            <Box mb={5} mt="2">
                {
                    mode == "client" && (
                        <ClientPanel isSelected={true} />
                    )
                }
                {
                    mode == "ghostwriter" && (
                        <GhostwriterPanel />
                    )
                }
            </Box>
        </Page>
    );
};

Collaboration.getInitialProps = async ({query}) => {
    // console.log(query);
    return {query};
  }
  
  export default Collaboration;
  